import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthorisedSubNavLink } from '../../Auth/AuthorisedSubNavLink';
import { SubNavProps } from '../SubNavLinks';

const UserManagementSubNav: React.FC<SubNavProps> = props => {
  const { t } = useTranslation();

  useEffect(() => {
    props.setHeading(t('mainnav.userManagement'));
  });

  return (
    <>
      <AuthorisedSubNavLink
        permissions={['ManageUsers']}
        to={'/user-management/users'}
        icon="users"
        label={t('userManagement.label')}
      />
      <AuthorisedSubNavLink
        permissions={['ManageUsers']}
        featureFlag={'role-management-ui'}
        to={`/user-management/roles`}
        icon="user-tag"
        label={t('roleManagement.label')}
      />
      <AuthorisedSubNavLink
        permissions={['ManageSftpUsers']}
        to={`/user-management/sftp-users`}
        icon="users"
        label={t('sftpManagement.label')}
      />
    </>
  );
};

export default UserManagementSubNav;
